import { toast } from "react-toastify";
import { azureFetch } from "../../../api/azureFetch";

export const markAsRead = (ids) => {
    return azureFetch("markasREAD", {
        alert_ids: ids,
        status: 'READ'
    })
}


export const markSelectedAsRead = async (selectedRows, refreshData, setSelectedRows) => {
    const selectedIds = selectedRows.map(({ id }) => id);
    try {
        // Wait for all markAsRead calls to complete
        await markAsRead(selectedIds);
        // Show success toast and refresh data only after all are marked as read
        toast.success("Alert Status Updated", 2);
        refreshData();
        setSelectedRows([]);
    } catch (error) {
        toast.error("Error Updating Alert Status");
    }
};